import { SVGProps } from 'react'

export const HourGlass = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M12 14.667l-.007-4L9.333 8l2.66-2.673L12 1.333H4v4L6.667 8 4 10.66v4.007h8zM5.333 5V2.667h5.334V5L8 7.667 5.333 5z"
    ></path>
  </svg>
)
